import React from "react";
import { Box } from "@mui/material";
import PartTable from "./PartTable";
import SectionSubheading from "./SectionSubheading";

/**
 * PaintingChecklist - Component for managing painting parts and related images with Formik
 * @param {Object} props - Component props
 * @param {string} props.coatType - Type of coat (e.g., "Painting")
 * @param {boolean} props.viewOnly - Whether the component is in view-only mode
 * @param {Object} props.values - Formik values object
 * @param {Object} props.errors - Formik errors object
 * @param {Object} props.touched - Formik touched object
 * @param {Function} props.setFieldValue - Formik setFieldValue function
 * @param {Function} props.onEditTemplate - Callback when edit template button is clicked
 */

// No dummy parts in production – keep Formik as source of truth

const PaintingChecklist = ({
  viewOnly = false,
  coatType,
  values,
  errors,
  touched,
  setFieldValue,
  paintingChecklistImages,
  onEditTemplate,
}) => {
  return (
    <Box sx={{ mt: 2 }}>
      <SectionSubheading title="Painting Checklist" />

      {/* Part Table Section */}
      <Box sx={{ mt: 3 }}>
        <PartTable
          viewOnly={viewOnly}
          data={values?.paintingChecklist?.parts}
          onPartTableRowsChange={(updatedParts) => {
            setFieldValue("paintingChecklist.parts", updatedParts);
          }}
          images={values?.paintingChecklist?.images}
          errors={errors?.paintingChecklist?.parts}
          touched={touched?.paintingChecklist?.parts}
          showStageFields={true}
          onEdit={
            coatType === "primer" && !viewOnly ? onEditTemplate : undefined
          }
        />
      </Box>
    </Box>
  );
};

export default PaintingChecklist;
